export enum TitleIndex {
    H1,
    H2,
    H3,
    H4
}
